import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { customerServiceCustomerDetailsEntryPoint } from '@jira/spa-apps__customer-service-customer-details/src/customerServiceCustomerDetailsEntryPoint.entrypoint.tsx';
import { l1CustomersProjectProviderResource } from '@jira/router-resources__customer-service-l1-customers-project-provider/src/l1CustomersProjectProviderResource.tsx';
import { CustomerDetailsPageQueryResource } from '@jira/router-resources__service-desk-customer-service-customer-details/src/CustomerDetailsPageQueryResource.tsx';
import { EntitlementsQueryResource } from '@jira/router-resources__service-desk-customer-service-customer-details/src/EntitlementsQueryResource.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { csmCustomerDetailsRoute } from '@jira/router-routes__customer-services-customers-routes/src/csmCustomerDetailsRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';

const csmCustomerDetailsPageEntryPoint = createPageEntryPoint({
	main: customerServiceCustomerDetailsEntryPoint,
});

export const csmCustomerDetailsRouteEntry: Route = createEntry(csmCustomerDetailsRoute, () => ({
	group: 'customer-service',
	perfMetricKey: 'customer-service.csm-customer-details',
	layout: globalLayout,

	navigation: {
		menuId: MenuIdCustomerExperiences,
		sidebarId: SidebarIdCsmApp,
	},

	entryPoint() {
		return fg('csm_appification_standalone_navigation')
			? csmCustomerDetailsPageEntryPoint
			: notFoundPageEntrypoint;
	},

	resources: [
		...getCustomerServiceL1NavigationResources(),
		CustomerDetailsPageQueryResource,
		EntitlementsQueryResource,
		l1CustomersProjectProviderResource,
	],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
